import React from 'react';
import { UserGroupIcon as HeroUserGroupIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type UserGroupIconProps = Omit<IconProps, 'children'>;

export const UserGroupIcon: React.FC<UserGroupIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroUserGroupIcon />
        </Icon>
    );
};
